import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Ticket from './Ticket.jsx';
import TrackContainer from './TrackContainer.jsx';

import { ticketsPropType } from '../propTypes.js';

function TicketListing({
  isBlock = false, isFetchingticketAvailability = true, requireEventIds, tickets, tmData = undefined,
}) {
  const siteType = window.location.host.includes('grandprix') ? 'formula-one' : 'moto-gp';

  const cardClass = '.c-card';

  const locations = tickets.map((ticket) => ({
    locationId: ticket.locationId,
    xCoord: ticket.locationCoordinates.xCoord,
    yCoord: ticket.locationCoordinates.yCoord,
  }));

  const [selectedLocationId, setSelectedLocationId] = useState('');

  const handleMouseEnterTicket = (e) => setSelectedLocationId(e.target.closest(cardClass).dataset.locationId);
  const handleMouseLeaveTicket = () => setSelectedLocationId('');

  const handleTouchStartTicket = (e) => {
    handleMouseLeaveTicket();
    handleMouseEnterTicket(e);
  };

  const renderNoTickets = () => (
    <div className="o-col u-align-center u-margin-bottom-medium">
      <p className="u-intro-text">No tickets found, please adjust the filters above.</p>
    </div>
  );

  const renderTickets = () => {
    const unsortedTickets = tickets.reduce((displayedTickets, ticket) => {
      const variant = ticket.days[0];
      const tmDataItem = (tmData && tmData.length > 0)
        ? tmData.filter((object) => object.eventId === variant.eventId)[0]
        : null;

      let soldOut = false;

      // If Ticketmaster data exists for this variant, use its parameters
      if (tmDataItem && (
        (tmDataItem.useFallback && !variant.fallbackStatus.showLink)
        || (!tmDataItem.useFallback && !tmDataItem.showLink)
      )) soldOut = true;

      // If Ticketmaster data doesn't exist AND not required, check fallback data
      if (
        !tmDataItem && !requireEventIds && !variant.fallbackStatus.showLink && !soldOut
      ) soldOut = true;

      // Hide sold out tickets from the block view
      if (isBlock && soldOut) return displayedTickets;

      const isSellingFast = !tmDataItem || tmDataItem.useFallback
        ? variant.fallbackStatus.type === 'sellingFast'
        : tmDataItem && tmDataItem.statusCode === 'FEW_TICKETS_LEFT';

      displayedTickets.push( // eslint-disable-line function-paren-newline
        <div className="u-spacing-bottom-base" key={ticket.title} data-soldout={soldOut}>
          <Ticket
            bookLink={variant.bookLink}
            detailsLink={variant.detailsLink}
            fallbackStatus={variant.fallbackStatus}
            handleMouseEnterTicket={handleMouseEnterTicket}
            handleMouseLeaveTicket={handleMouseLeaveTicket}
            handleTouchStartTicket={handleTouchStartTicket}
            location={ticket.location}
            locationId={ticket.locationId}
            isBlock={isBlock}
            isDynamicPricing={variant.dynamicPricing}
            isSellingFast={isSellingFast}
            price={variant.price}
            ticketmasterStatus={tmDataItem || {
              showLink: false,
              status: '',
              useFallback: true,
            }}
            title={ticket.title}
          />
        </div>,
      ); // eslint-disable-line function-paren-newline

      return displayedTickets;
    }, []);

    const sortedTickets = unsortedTickets.sort((a, b) => {
      if (a.props['data-soldout'] === b.props['data-soldout']) {
        return a.key < b.key ? -1 : 1;
      }

      return a.props['data-soldout'] ? 1 : -1;
    });

    return sortedTickets;
  };

  return (
    <section className="o-section">
      <div className="o-container">
        <div className="o-grid">
          {renderTickets().length === 0 && renderNoTickets()}

          <div className={`o-col ${isBlock ? '' : 'o-col--6-at-medium'}`}>
            <div>
              {tickets.length > 0 && renderTickets().length > 0 && renderTickets()}
            </div>
          </div>

          {!isBlock && (
            <div className="o-col o-col--6-at-medium c-track-map__wrapper">
              {tickets.length > 0 && (
                <TrackContainer
                  isFetchingticketAvailability={isFetchingticketAvailability}
                  locations={locations}
                  selectedLocationId={selectedLocationId}
                  tickets={tickets}
                  type={siteType}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

TicketListing.propTypes = {
  isBlock: PropTypes.bool,
  isFetchingticketAvailability: PropTypes.bool,
  requireEventIds: PropTypes.bool.isRequired,
  tickets: ticketsPropType.isRequired,
  tmData: PropTypes.array, // eslint-disable-line react/forbid-prop-types
};

export default TicketListing;
